"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var Info_1 = __importDefault(require("@mui/icons-material/Info"));
var BravasLoading_1 = __importDefault(require("../BravasLoading"));
function HeaderPage(_a) {
    var title = _a.title, description = _a.description, count = _a.count, actionButton = _a.actionButton, endTitleObject = _a.endTitleObject, isLoading = _a.isLoading;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", alignItems: "flex-start", justifyContent: "space-between" }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", alignItems: "center", spacing: 2, justifyContent: "flex-start" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h1" }, { children: title })), count !== undefined && +count > 0 && ((0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h1", style: { color: 'rgba(4, 30, 57, 0.3)', marginLeft: '10px' } }, { children: "".concat(count) }))), isLoading && (0, jsx_runtime_1.jsx)(BravasLoading_1.default, { size: "25px" })] })), endTitleObject] })), (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", justifyContent: "space-between", alignItems: "flex-start", sx: {
                    mt: 4,
                    mb: 5,
                } }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", alignItems: "flex-start", flex: 1 }, { children: [(0, jsx_runtime_1.jsx)(Info_1.default, { sx: {
                                    height: 24,
                                    width: 24,
                                    margin: '0px 10px 0px 0px',
                                    color: 'rgba(80, 97, 115, 0.7)',
                                } }), (0, jsx_runtime_1.jsx)(material_1.Stack, __assign({ direction: "column", maxWidth: "868px" }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "body1", color: "text.secondary" }, { children: description })) }))] })), actionButton] }))] }));
}
exports.default = HeaderPage;
HeaderPage.defaultProps = {
    title: '',
    description: '',
    count: undefined,
    actionButton: undefined,
    endTitleObject: undefined,
    isLoading: false,
};
//# sourceMappingURL=HeaderPage.js.map